import { createContext } from "react";

const PlaceholderContext = createContext();

export { PlaceholderContext };